import React, { useState } from 'react';
import CotizadorCV from './cotizadorCV';
import { CrearCotizacionNBSCV } from './crearCotizacionNBSCV';
import type { ICotizacionNBS } from '../../../modelos/CotizadorNBS/entidades/ICotizacionNBS';

export const CotizadorNBSCV: React.FC = () => {
    const [vistaActiva, setVistaActiva] = useState<'lista' | 'crear'>('lista');
    const [cotizacionAEditar, setCotizacionAEditar] = useState<ICotizacionNBS | null>(null);

    const manejarEdicion = (cotizacion: ICotizacionNBS) => {
        setCotizacionAEditar(cotizacion);
        setVistaActiva('crear');
    };

    if (vistaActiva === 'crear') {
        return <CrearCotizacionNBSCV alTerminar={() => { setVistaActiva('lista'); setCotizacionAEditar(null); }} cotizacionInicialId={cotizacionAEditar?.Id} />;
    }

    return <CotizadorCV alCrearNueva={() => { setCotizacionAEditar(null); setVistaActiva('crear'); }} alEditar={manejarEdicion} />;
};
